<div class="chart-wrapper">
  <div class="chart-box">
      <div class="chartjs-size-monitor" style="position: absolute; left: 0px; top: 0px; right: 0px; bottom: 0px; overflow: hidden; pointer-events: none; visibility: hidden; z-index: -1;"><div class="chartjs-size-monitor-expand" style="position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;pointer-events:none;visibility:hidden;z-index:-1;"><div style="position:absolute;width:1000000px;height:1000000px;left:0;top:0"></div></div><div class="chartjs-size-monitor-shrink" style="position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;pointer-events:none;visibility:hidden;z-index:-1;"><div style="position:absolute;width:200%;height:200%;left:0; top:0"></div></div></div>
      <canvas #chartHost width="140" height="140" class="chartjs-render-monitor" style="display: block; width: 140px; height: 140px;"></canvas>
  </div>
  <div class="chart-box">
    <div #chartLegendHost class="chart-legend-custom">
      <ul>
        <li>
          @for (item of legends; track $index; let i = $index) {
            <div class="chart-legend-label-wrapper"
              [style.color]="item.color">
              <span class="chart-legend-label-txt"
                  style="max-width:83% !important;"
                  ngbTooltip="{{item.textToolTip}}"
                  (click)="legendClick(i)">
                  {{item.text}}
              </span>
              <span class="chart-legend-label-value">{{item.value}}{{isPercentage ? '%' : ''}}</span>
            </div>
          }
        </li>
      </ul>
    </div>
  </div>
</div>
